import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { conformToMask } from "angular2-text-mask";
import { FormMaskConstants } from "src/app/constants/form-mask.constants";
import { Agencies } from "src/app/models/dmv/models";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { GlobalService } from "src/app/services/global/global.service";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { USERDataService } from "src/app/services/user/user-data.service";
import { USERStoreService } from "src/app/services/user/user-store.service";

@Component({
	selector: "app-contact-info",
	templateUrl: "./contact-info.component.html",
	styleUrls: ["./contact-info.component.css"]
})
export class ContactInfoComponent implements OnInit, OnDestroy {
	public agencies: Agencies;
	public phoneMask = FormMaskConstants.PHONE_MASK;
	public isloading: boolean = false;
	public errorMessage: string;
	constructor(
		public router: Router,
		public megStoreService: MEGStoreService,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public userStoreService: USERStoreService,
		public userDataService: USERDataService,
		private cd: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.megStoreService.configurationsData$.subscribe(data => {
			if (data && data.megConfig) {
				this.agencies = data.megConfig.agencies;
			}
		});
	}
	ngOnDestroy() {
		this.userStoreService.outComeText = "";
	}
	public cancel() {
		this.back();
	}
	public back() {
		this.router.navigate(["profile"], { skipLocationChange: true });
	}

	public changeEmail() {
		this.router.navigate(["change-email-address"], {
			skipLocationChange: true
		});
	}
	public formatedPhoneNumber(phone) {
		if (phone) {
			return conformToMask(phone.replace(/\D+/g, ""), this.phoneMask, {})
				.conformedValue;
		} else {
			return "";
		}
	}
	public changePassword() {
		this.userStoreService.outComeText = null;
		this.router.navigate(["change-password"], { skipLocationChange: true });
	}
	public editContactInfo() {
		this.router.navigate(["edit-contact-info"], { skipLocationChange: true });
	}
	public taxCollectorName() {
		const _this = this;
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().contactInfo
		) {
			const agency = this.agencies.filter(function(item) {
				return (
					item.agencyID ===
					"" + _this.userStoreService.getUserProfile().contactInfo.agencyID
				);
			});

			if (agency && agency.length > 0) {
				return agency[0].name;
			} else {
				return null;
			}

			//return agency[0].name;
		} else {
			return null;
		}
	}

	public accountCancellation() {
		this.isloading = true;
		this.errorMessage = "";
		this.userDataService
			.accountCancellation(this.dmvStoreService.sessionGUID, "")
			.subscribe(response => {
				if (response && response.status) {
					this.globalService.setDirectURLCall(false);
					this.isloading = false;
					if (response.headers.get("outcomeCode") === "0") {
						// this.globalService.updateHeaderImageType(HeaderImageType.DMV);
						this.dmvStoreService.cancellationTokenData = response.body;
						this.cd.markForCheck();
						this.router.navigate(["app-enrollment-cancellation"], {
							skipLocationChange: true
						});
					} else {
						this.errorMessage = response.headers.get("outcomeText");
					}
				}
				this.cd.markForCheck();
			});
	}
	public cancelEnrollment() {
		this.accountCancellation();
	}
}
